import { render } from "./CalendarLessonsPopup.vue?vue&type=template&id=07e52fd3&scoped=true"
import script from "./CalendarLessonsPopup.vue?vue&type=script&lang=js"
export * from "./CalendarLessonsPopup.vue?vue&type=script&lang=js"

import "./CalendarLessonsPopup.vue?vue&type=style&index=0&id=07e52fd3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e52fd3"]])

export default __exports__